<template>
  <span class="current-time">
    <i class="bi bi-calendar3 date-icon"></i>
    {{ currentDate }}
    <i class="bi bi-clock time-icon"></i>
    {{ currentTime }}
  </span>
</template>

<script>
import moment from 'moment';

export default {
  name: 'CurrentTime',
  props: {
    dateTimeMoment: Object,
  },
  computed: {
    currentDate() {
      if (this.isToday()) {
        return this.$t('generic.today') + ', ' + this.dateTimeMoment.format('DD') + ' ' +
            this.$t('generic.month.' + this.dateTimeMoment.format('MM'));
      }

      return this.dateTimeMoment.format('DD') + ' ' +
          this.$t('generic.month.' + this.dateTimeMoment.format('MM')) + ' ' +
          this.dateTimeMoment.format('yyyy');
    },
    currentTime() {
      return this.dateTimeMoment.format('HH:mm');
    },
  },
  methods: {
    isToday() {
      return this.dateTimeMoment.format('DD.MM.yyyy') === moment().format('DD.MM.yyyy');
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.current-time {
  color: $default-text-color;
  font-size: 1.2rem;

  .date-icon {
    margin-right: 8px;
  }

  .time-icon {
    margin-left: 20px;
    margin-right: 8px;
  }
}
</style>
